import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { WIDGET_TYPE } from './AuthorizeConstant'
import { RootState } from '../../../store/Store'
import ATLoaderContainer from '../loaderContainer/ATLoaderContainer'
import ATModuleMessage from '../message/ATModuleMessage'
import { MdBlockFlipped } from 'react-icons/md'

interface AuthorizeProps {
  children: React.ReactNode
  widgetId: string
  widgetType: number
}

const Authorize: React.FC<AuthorizeProps> = ({
  children,
  widgetId,
  widgetType,
}) => {
  const { t } = useTranslation(['translation'])
  const permissionList = useSelector(
    (state: RootState) => state?.atlas?.permissionList,
  )

  const isAuthorized = permissionList?.includes(widgetId)

  if (
    widgetType === WIDGET_TYPE.BUTTON ||
    widgetType === WIDGET_TYPE.CHECKBOX ||
    widgetType === WIDGET_TYPE.SWITCH ||
    widgetType === WIDGET_TYPE.DROPDOWN_ITEM
  ) {
    if (isAuthorized) {
      return <>{children}</>
    }
    return React.cloneElement(children as React.ReactElement, {
      disabled: true,
    })
  }

  if (widgetType === WIDGET_TYPE.VIEW) {
    if (isAuthorized) {
      return <>{children}</>
    } else {
      return (
        <ATLoaderContainer>
          <ATModuleMessage
            message={t('common.un_authorized')}
            icon={<MdBlockFlipped className="icon" size={40} />}
          />
        </ATLoaderContainer>
      )
    }
  }

  return <>{children}</>
}

export default Authorize
